import React, { useId } from "react";
import { moonPhase, illumination } from "@/lib/moon";

export const MoonDisc = ({ date = new Date(), size = 96, className = "" }) => {
  const rawId = useId();
  const uid = rawId.replace(/[^a-zA-Z0-9]/g, "");
  const phase = moonPhase(date);
  const illum = illumination(phase);
  const waxing = phase < 0.5;
  const r = 46;
  const shadowCx = (waxing ? -1 : 1) * 2 * r * illum;

  return (
    <svg viewBox="-50 -50 100 100" width={size} height={size} className={className} role="img">
      <defs>
        <radialGradient id={`ml${uid}`} cx="38%" cy="34%" r="75%">
          <stop offset="0%" stopColor="#fdf6e3" />
          <stop offset="70%" stopColor="#d9cdb0" />
          <stop offset="100%" stopColor="#9c927a" />
        </radialGradient>
        <clipPath id={`mc${uid}`}><circle r={r} /></clipPath>
      </defs>
      <g clipPath={`url(#mc${uid})`}>
        <circle r={r} fill={`url(#ml${uid})`} />
        <circle cx="-14" cy="-10" r="7" fill="#0000000f" />
        <circle cx="12" cy="8" r="9" fill="#0000000f" />
        <circle cx="6" cy="-18" r="4" fill="#0000000f" />
        <circle r={r} cx={shadowCx} fill="#0b0d12" fillOpacity="0.97" />
      </g>
      <circle r={r} fill="none" stroke="rgba(217,169,80,0.35)" strokeWidth="1.5" />
    </svg>
  );
};

export default MoonDisc;
